// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__M08dW","SwitchInputWrapper":"Switch_SwitchInputWrapper__L8A-p","spindindust":"Switch_spindindust__2vvny"};